var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Box, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CustomButton from '../../components/buttonComponent/CustomButton';
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from '../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { applyVendorFieldConfig, buildGroupsFromFieldConfig, DynamicFormOverridesProvider, hasConfigSectionMapping, mergeVendorFieldConfigIntoLayout, normaliseConfigKey, } from '../../components/FormComponents/dynamicForm';
import constants, { APPLICATION_TYPES } from '../../config/constants';
import { utility } from '../../utils';
import { NavigationConfig } from '../../utils/navigation_config';
import ApplicationContextBar from './components/ApplicationContextBar';
import AddNewLocationDialog from './components/AddNewLocationDialog';
import ApplicationPreviewDialog from './components/ApplicationPreviewDialog';
import ApplicationStepRail from './components/ApplicationStepRail';
import AssetInformationStep from './components/AssetInformationStep';
import CustomerInformationStep from './components/CustomerInformationStep';
import ScheduleTakedownLocList from './components/ScheduleTakedownLocList';
import { fetchLocAmountsInfo } from './schedule_takedown_service';
import DocumentSignerPreviewStep from './components/DocumentSignerPreviewStep';
import FinanceAndDocumentsStep from './components/FinanceAndDocumentsStep';
import GuarantorInformationStep from './components/GuarantorInformationStep';
import StepPanelHeader from './components/StepPanelHeader';
import WizardStepForm from './components/WizardStepForm';
import { areAllCustomersSoleProprietorships, ASSET_LOCATION_TYPE, buildAssetLocationChoices, calculateTotalAssetCost, CREATE_APPLICATION_STEPS, CREATE_APPLICATION_STEP_ID, CUSTOMER_ASPIRE_FIELD, CUSTOMER_FIELD, describeAssetLocation, getCustomerRecordLabel, getStepLabel, isCanadianProgram, collectsGuarantorForApplicationType, isConsumerProgramName, isSectionInApplicationType, isStepInApplicationType, MAIN_ADDRESS_PREFIX, toAssetLocationOptions, } from './config/create_application_schema';
import { buildAddressFieldName } from './config/form_field_factories';
import { asText } from './service_helpers';
import { enhanceConfiguredField, isIgnoredConfigGroup, STEP_ID_BY_CONFIG_GROUP, } from './config/field_config_mapping';
import { CREATE_COMMENT_STATUS } from './application_comment_service';
import { readPrimaryCustomerName, readSignerGuarantors, toApiApplicationType, } from './create_application_payload';
import { submitCreateApplication } from './create_application_service';
import { UNSAVED_CHANGES_MESSAGE, UNSAVED_CHANGES_TITLE, useUnsavedChangesGuard, } from './use_unsaved_changes_guard';
import CreateApplicationWrapper, { FOOTER_ICON_SX, FOOTER_PRIMARY_COLOR, INERT_WHEN_DISABLED_SX, stepPanelSx, SUBMIT_ERROR_SX, } from './CreateApplicationStyles';
import { WIZARD_COLORS } from '../../components/FormComponents/dynamicForm';
var NOT_SELECTED = 'Not Selected';
var DEFAULT_WIZARD_TITLE = 'New LOC Application';
var STEP_INVALID_MESSAGE = 'Please complete the highlighted fields before continuing.';
var NO_CONFIG_MESSAGE = 'No field configuration is published for this application type, so the standard form is shown.';
var CONFIGURED_STEP_ID_PREFIX = 'configuredGroup:';
var DEFAULT_APPLICATION_CONTEXT = {
    program: NOT_SELECTED,
};
var CONTEXT_LABELS = [
    { key: 'program', label: 'Program' },
];
var STEP_ICONS = (_a = {},
    _a[CREATE_APPLICATION_STEP_ID.CustomerInformation] = React.createElement(PersonOutlineIcon, null),
    _a[CREATE_APPLICATION_STEP_ID.GuarantorInformation] = React.createElement(BadgeOutlinedIcon, null),
    _a[CREATE_APPLICATION_STEP_ID.DocumentSignerInformation] = (React.createElement(DriveFileRenameOutlineOutlinedIcon, null)),
    _a[CREATE_APPLICATION_STEP_ID.AssetInformation] = React.createElement(HandymanOutlinedIcon, null),
    _a[CREATE_APPLICATION_STEP_ID.FilesFinanceAndComments] = React.createElement(DescriptionOutlinedIcon, null),
    _a);
var EMPTY_PREVIEW = {
    customers: [],
    guarantors: [],
    signerGuarantors: [],
    isGuarantorIncluded: false,
};
var CreateApplication = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var navigate = useNavigate();
    var location = useLocation();
    var routeState = ((_a = location.state) !== null && _a !== void 0 ? _a : {});
    var _l = React.useState(routeState), selection = _l[0], setSelection = _l[1];
    var applicationContext = React.useMemo(function () { return ({ program: selection.program || DEFAULT_APPLICATION_CONTEXT.program }); }, [selection]);
    var _m = React.useState([]), signerGuarantors = _m[0], setSignerGuarantors = _m[1];
    var _o = React.useState([]), guarantorCustomerOptions = _o[0], setGuarantorCustomerOptions = _o[1];
    var _p = React.useState(null), selectedLoc = _p[0], setSelectedLoc = _p[1];
    var _q = React.useState(null), locDetails = _q[0], setLocDetails = _q[1];
    var _r = React.useState(false), areAllCustomersSoleProp = _r[0], setAreAllCustomersSoleProp = _r[1];
    var _s = React.useState(0), activeStepIndex = _s[0], setActiveStepIndex = _s[1];
    var _t = React.useState([]), completedStepIndexes = _t[0], setCompletedStepIndexes = _t[1];
    var _u = React.useState(false), isSubmitting = _u[0], setIsSubmitting = _u[1];
    var _v = React.useState(''), submitError = _v[0], setSubmitError = _v[1];
    var _w = React.useState(''), successMessage = _w[0], setSuccessMessage = _w[1];
    var _x = React.useState({}), autofillFiles = _x[0], setAutofillFiles = _x[1];
    var _y = React.useState(''), draftApplicationId = _y[0], setDraftApplicationId = _y[1];
    var _z = React.useState([]), assetLocationChoices = _z[0], setAssetLocationChoices = _z[1];
    var _0 = React.useState(false), isAddLocationOpen = _0[0], setIsAddLocationOpen = _0[1];
    var _1 = React.useState(0), totalAssetCost = _1[0], setTotalAssetCost = _1[1];
    var _2 = React.useState(false), isPrimaryCustomerVeteran = _2[0], setIsPrimaryCustomerVeteran = _2[1];
    var _3 = React.useState(''), primaryCustomerState = _3[0], setPrimaryCustomerState = _3[1];
    var _4 = React.useState([]), statesList = _4[0], setStatesList = _4[1];
    var _5 = React.useState(EMPTY_PREVIEW), documentSignerPreview = _5[0], setDocumentSignerPreview = _5[1];
    var assetLocationOptions = React.useMemo(function () { return toAssetLocationOptions(assetLocationChoices); }, [assetLocationChoices]);
    var stepRefs = React.useRef([]);
    var vendorFieldConfig = (_b = selection.fieldConfig) !== null && _b !== void 0 ? _b : null;
    var configuredGroups = React.useMemo(function () { return buildGroupsFromFieldConfig(vendorFieldConfig, { enhanceField: enhanceConfiguredField }); }, [vendorFieldConfig]);
    var _6 = React.useMemo(function () {
        var stepIdByName = new Map();
        CREATE_APPLICATION_STEPS.forEach(function (step) {
            stepIdByName.set(normaliseConfigKey(step.id), step.id);
            stepIdByName.set(normaliseConfigKey(step.label), step.id);
        });
        var byStepId = {};
        var rawByStepId = {};
        var unmatched = [];
        configuredGroups.forEach(function (group) {
            var _a;
            var _b, _c, _d;
            var groupKey = normaliseConfigKey(group.key);
            if (isIgnoredConfigGroup(groupKey)) {
                return;
            }
            var stepId = (_c = (_b = STEP_ID_BY_CONFIG_GROUP[groupKey]) !== null && _b !== void 0 ? _b : stepIdByName.get(groupKey)) !== null && _c !== void 0 ? _c : stepIdByName.get(normaliseConfigKey(group.label));
            if (!stepId) {
                unmatched.push(group);
                return;
            }
            byStepId[stepId] = ((_d = byStepId[stepId]) !== null && _d !== void 0 ? _d : []).concat(group.sections);
            var rawGroup = vendorFieldConfig === null || vendorFieldConfig === void 0 ? void 0 : vendorFieldConfig[group.key];
            if (rawGroup) {
                rawByStepId[stepId] = __assign(__assign({}, rawByStepId[stepId]), (_a = {}, _a[group.key] = rawGroup, _a));
            }
        });
        return {
            sectionsByStepId: byStepId,
            configByStepId: rawByStepId,
            unmatchedGroups: unmatched,
        };
    }, [configuredGroups, vendorFieldConfig]), sectionsByStepId = _6.sectionsByStepId, configByStepId = _6.configByStepId, unmatchedGroups = _6.unmatchedGroups;
    var vendorConfig = (_c = selection.vendorConfig) !== null && _c !== void 0 ? _c : null;
    var isCanadaProgram = isCanadianProgram((_d = selection.programCountry) !== null && _d !== void 0 ? _d : '', (_e = selection.program) !== null && _e !== void 0 ? _e : '');
    var isConfigLedApplicationType = true;
    var isLineOfCreditType = selection.applicationType === APPLICATION_TYPES.LOC ||
        selection.applicationType === APPLICATION_TYPES.DORF;
    var isConsumerProgram = isConsumerProgramName((_f = selection.program) !== null && _f !== void 0 ? _f : '');
    var isScheduleTakedownType = selection.applicationType === APPLICATION_TYPES.SCH;
    var collectsGuarantor = collectsGuarantorForApplicationType((_g = selection.applicationType) !== null && _g !== void 0 ? _g : '');
    var keepSectionsForProgram = React.useCallback(function (sections) {
        return sections.filter(function (section) {
            var _a, _b;
            return isSectionInApplicationType(section.id, {
                applicationType: (_a = selection.applicationType) !== null && _a !== void 0 ? _a : '',
                programName: (_b = selection.program) !== null && _b !== void 0 ? _b : '',
                areAllCustomersSoleProp: areAllCustomersSoleProp,
            });
        });
    }, [areAllCustomersSoleProp, selection.applicationType, selection.program]);
    var resolveSections = React.useCallback(function (stepKey, fallbackSections) {
        var stepConfig = configByStepId[stepKey];
        if (stepConfig && hasConfigSectionMapping(fallbackSections)) {
            return keepSectionsForProgram(mergeVendorFieldConfigIntoLayout(fallbackSections, stepConfig, {
                enhanceField: enhanceConfiguredField,
                isConfigAuthoritative: isConfigLedApplicationType,
            }));
        }
        var configuredSections = sectionsByStepId[stepKey];
        if (configuredSections && configuredSections.length > 0) {
            return keepSectionsForProgram(configuredSections);
        }
        return keepSectionsForProgram(applyVendorFieldConfig(fallbackSections, vendorFieldConfig));
    }, [
        configByStepId,
        isConfigLedApplicationType,
        keepSectionsForProgram,
        sectionsByStepId,
        vendorFieldConfig,
    ]);
    var steps = React.useMemo(function () {
        var designedSteps = CREATE_APPLICATION_STEPS.filter(function (step) {
            var _a, _b;
            return isStepInApplicationType(step.id, {
                applicationType: (_a = selection.applicationType) !== null && _a !== void 0 ? _a : '',
                programName: (_b = selection.program) !== null && _b !== void 0 ? _b : '',
                areAllCustomersSoleProp: areAllCustomersSoleProp,
            });
        }).map(function (step) {
            var _a;
            return ({
                id: step.id,
                label: getStepLabel(step, (_a = selection.applicationType) !== null && _a !== void 0 ? _a : ''),
            });
        });
        var takenLabels = new Set(designedSteps.map(function (step) { return normaliseConfigKey(step.label); }));
        var configuredSteps = unmatchedGroups.reduce(function (kept, group) {
            var labelKey = normaliseConfigKey(group.label);
            if (takenLabels.has(labelKey)) {
                return kept;
            }
            takenLabels.add(labelKey);
            kept.push({
                id: "".concat(CONFIGURED_STEP_ID_PREFIX).concat(group.key),
                label: group.label,
            });
            return kept;
        }, []);
        return __spreadArray(__spreadArray([], designedSteps, true), configuredSteps, true);
    }, [
        areAllCustomersSoleProp,
        selection.applicationType,
        selection.program,
        unmatchedGroups,
    ]);
    var applicationTitle = (_h = selection.wizardTitle) !== null && _h !== void 0 ? _h : DEFAULT_WIZARD_TITLE;
    var isLastStep = activeStepIndex === steps.length - 1;
    var activeStep = (_j = steps[activeStepIndex]) !== null && _j !== void 0 ? _j : steps[0];
    var stepRefSetters = React.useMemo(function () {
        return steps.map(function (_step, stepIndex) { return function (handle) {
            stepRefs.current[stepIndex] = handle;
        }; });
    }, [steps]);
    var stepIndexByIdRef = React.useRef({});
    stepIndexByIdRef.current = React.useMemo(function () {
        return steps.reduce(function (indexes, step, stepIndex) {
            var _a;
            return (__assign(__assign({}, indexes), (_a = {}, _a[step.id] = stepIndex, _a)));
        }, {});
    }, [steps]);
    var readStepPayload = React.useCallback(function (stepId) { var _a, _b, _c; return (_c = (_b = stepRefs.current[(_a = stepIndexByIdRef.current[stepId]) !== null && _a !== void 0 ? _a : -1]) === null || _b === void 0 ? void 0 : _b.getPayload()) !== null && _c !== void 0 ? _c : {}; }, []);
    var hasNoConfiguredFields = Boolean(selection.applicationType) && configuredGroups.length === 0;
    var contextItems = React.useMemo(function () {
        var _a;
        var programItems = CONTEXT_LABELS.map(function (_a) {
            var key = _a.key, label = _a.label;
            return ({
                key: key,
                label: label,
                value: applicationContext[key],
            });
        });
        var dealerEntries = (_a = selection.dealerEntries) !== null && _a !== void 0 ? _a : [];
        var dealerItems = dealerEntries.flatMap(function (entry, index) {
            var suffix = dealerEntries.length > 1 ? " ".concat(index + 1) : '';
            var items = [
                { key: "dealer-".concat(index), label: "Dealer".concat(suffix), value: entry.dealer },
                { key: "location-".concat(index), label: "Location".concat(suffix), value: entry.location },
            ];
            if (entry.salesRep) {
                items.push({
                    key: "salesRep-".concat(index),
                    label: "Sales Rep".concat(suffix),
                    value: entry.salesRep,
                });
            }
            return items;
        });
        return __spreadArray(__spreadArray([], programItems, true), dealerItems, true);
    }, [applicationContext, selection.dealerEntries]);
    var apiApplicationType = React.useMemo(function () { var _a; return toApiApplicationType((_a = selection.applicationType) !== null && _a !== void 0 ? _a : ''); }, [selection.applicationType]);
    var handleAutofillDocument = React.useCallback(function (sourceKey, file) {
        setAutofillFiles(function (previousFiles) {
            var _a;
            return (__assign(__assign({}, previousFiles), (_a = {}, _a[sourceKey] = file, _a)));
        });
    }, []);
    var handleAutofillDocumentRemove = React.useCallback(function (sourceKey) {
        setAutofillFiles(function (previousFiles) {
            var remaining = __assign({}, previousFiles);
            delete remaining[sourceKey];
            return remaining;
        });
    }, []);
    var autofillContext = React.useMemo(function () { return ({
        applicationType: apiApplicationType,
        applicationId: draftApplicationId,
        programAspireOId: selection.programAspireOId,
        programId: selection.programId,
        salesRepId: selection.salesRepId,
        dealerAspireOId: selection.dealershipId,
        locationAspireOId: selection.locationId,
    }); }, [
        apiApplicationType,
        draftApplicationId,
        selection.dealershipId,
        selection.locationId,
        selection.programAspireOId,
        selection.programId,
        selection.salesRepId,
    ]);
    var documentUploadContext = React.useMemo(function () { return ({
        applicationType: apiApplicationType,
        applicationId: draftApplicationId,
        programAspireOId: selection.programAspireOId,
        programId: selection.programId,
    }); }, [
        apiApplicationType,
        draftApplicationId,
        selection.programAspireOId,
        selection.programId,
    ]);
    var applicationCommentContext = React.useMemo(function () { return ({
        applicationId: draftApplicationId,
        applicationType: apiApplicationType,
        status: CREATE_COMMENT_STATUS,
        programId: selection.programId,
        programAspireOId: selection.programAspireOId,
        salesRepId: selection.salesRepId,
        dealerAspireOId: selection.dealershipId,
        locationAspireOId: selection.locationId,
        locationCode: selection.locationCode,
    }); }, [
        apiApplicationType,
        draftApplicationId,
        selection.dealershipId,
        selection.locationCode,
        selection.locationId,
        selection.programAspireOId,
        selection.programId,
        selection.salesRepId,
    ]);
    var handleDraftApplicationId = React.useCallback(function (applicationId) {
        setDraftApplicationId(function (previous) { return previous || applicationId; });
    }, []);
    var isDriverLicenseAutofillEnabled = ((_k = selection.program) !== null && _k !== void 0 ? _k : '').toLowerCase().includes('consumer') || areAllCustomersSoleProp;
    var handleAddNewLocation = React.useCallback(function () { return setIsAddLocationOpen(true); }, []);
    var handleSaveNewLocation = React.useCallback(function (location) {
        setAssetLocationChoices(function (previousChoices) { return __spreadArray(__spreadArray([], previousChoices, true), [
            {
                label: describeAssetLocation(location),
                locationType: ASSET_LOCATION_TYPE.New,
                location: location,
            },
        ], false); });
        setIsAddLocationOpen(false);
        utility.alert('New Location saved successfully', constants.TOAST_TYPES.INFO);
    }, []);
    var markStepCompleted = React.useCallback(function (stepIndex) {
        setCompletedStepIndexes(function (previousSteps) {
            return previousSteps.includes(stepIndex) ? previousSteps : __spreadArray(__spreadArray([], previousSteps, true), [stepIndex], false);
        });
    }, []);
    var refreshDerivedStepData = React.useCallback(function (stepIndex) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (stepIndex === stepIndexByIdRef.current[CREATE_APPLICATION_STEP_ID.GuarantorInformation]) {
            var customers = readStepPayload(CREATE_APPLICATION_STEP_ID.CustomerInformation).customers;
            setSignerGuarantors(readSignerGuarantors(customers !== null && customers !== void 0 ? customers : []));
            setGuarantorCustomerOptions((customers !== null && customers !== void 0 ? customers : []).map(function (customer, index) { return ({
                label: getCustomerRecordLabel(index),
                value: asText(customer[CUSTOMER_ASPIRE_FIELD.CustomerAspireId]) ||
                    "customer-".concat(index + 1),
            }); }));
        }
        if (stepIndex === stepIndexByIdRef.current[CREATE_APPLICATION_STEP_ID.DocumentSignerInformation]) {
            var customerPayload = readStepPayload(CREATE_APPLICATION_STEP_ID.CustomerInformation);
            var guarantorPayload = readStepPayload(CREATE_APPLICATION_STEP_ID.GuarantorInformation);
            setDocumentSignerPreview({
                customers: (_a = customerPayload.customers) !== null && _a !== void 0 ? _a : [],
                guarantors: (_c = (_b = guarantorPayload.guarantorInformation) === null || _b === void 0 ? void 0 : _b.guarantors) !== null && _c !== void 0 ? _c : [],
                signerGuarantors: readSignerGuarantors((_d = customerPayload.customers) !== null && _d !== void 0 ? _d : []),
                isGuarantorIncluded: (_f = (_e = guarantorPayload.guarantorInformation) === null || _e === void 0 ? void 0 : _e.isGuarantorIncluded) !== null && _f !== void 0 ? _f : false,
            });
        }
        if (stepIndex === stepIndexByIdRef.current[CREATE_APPLICATION_STEP_ID.FilesFinanceAndComments]) {
            var assetPayload = readStepPayload(CREATE_APPLICATION_STEP_ID.AssetInformation);
            setTotalAssetCost(calculateTotalAssetCost((_g = assetPayload.assets) !== null && _g !== void 0 ? _g : []));
        }
    }, [readStepPayload]);
    var goToStep = React.useCallback(function (nextStepIndex) {
        var _a, _b, _c;
        var customerPayload = readStepPayload(CREATE_APPLICATION_STEP_ID.CustomerInformation);
        var customers = (_a = customerPayload.customers) !== null && _a !== void 0 ? _a : [];
        setAreAllCustomersSoleProp(areAllCustomersSoleProprietorships(customers));
        var primaryCustomer = (_b = customers[0]) !== null && _b !== void 0 ? _b : {};
        setIsPrimaryCustomerVeteran(Number(primaryCustomer[CUSTOMER_FIELD.VeteranStatus]) === 1);
        setPrimaryCustomerState(String((_c = primaryCustomer[buildAddressFieldName(MAIN_ADDRESS_PREFIX, 'State')]) !== null && _c !== void 0 ? _c : ''));
        setStatesList(customers.map(function (customer) {
            var _a, _b;
            return ({
                countryCode: String((_a = customer[CUSTOMER_FIELD.Country]) !== null && _a !== void 0 ? _a : ''),
                stateCode: String((_b = customer[CUSTOMER_FIELD.StateOfIncorporation]) !== null && _b !== void 0 ? _b : ''),
            });
        }));
        setAssetLocationChoices(function (previousChoices) {
            var _a;
            return __spreadArray(__spreadArray([], buildAssetLocationChoices((_a = customers[0]) !== null && _a !== void 0 ? _a : {}), true), previousChoices.filter(function (choice) { return choice.locationType === ASSET_LOCATION_TYPE.New; }), true);
        });
        setActiveStepIndex(nextStepIndex);
        refreshDerivedStepData(nextStepIndex);
    }, [readStepPayload, refreshDerivedStepData]);
    React.useEffect(function () {
        setActiveStepIndex(function (previousIndex) {
            return previousIndex > steps.length - 1 ? Math.max(steps.length - 1, 0) : previousIndex;
        });
    }, [steps.length]);
    var handleStepSelect = React.useCallback(function (nextStepIndex) {
        var _a;
        if (nextStepIndex === activeStepIndex) {
            return;
        }
        if (nextStepIndex > activeStepIndex && !((_a = stepRefs.current[activeStepIndex]) === null || _a === void 0 ? void 0 : _a.validate())) {
            utility.alert(STEP_INVALID_MESSAGE, constants.TOAST_TYPES.WARN);
            return;
        }
        if (nextStepIndex > activeStepIndex) {
            markStepCompleted(activeStepIndex);
        }
        goToStep(nextStepIndex);
    }, [activeStepIndex, goToStep, markStepCompleted]);
    var handleNext = React.useCallback(function () {
        handleStepSelect(activeStepIndex + 1);
    }, [activeStepIndex, handleStepSelect]);
    var handleBack = React.useCallback(function () {
        goToStep(Math.max(activeStepIndex - 1, 0));
    }, [activeStepIndex, goToStep]);
    var collectFiles = React.useCallback(function () {
        var files = __assign({}, autofillFiles);
        stepRefs.current.forEach(function (stepHandle, stepIndex) {
            var _a;
            Object.entries((_a = stepHandle === null || stepHandle === void 0 ? void 0 : stepHandle.getFiles()) !== null && _a !== void 0 ? _a : {}).forEach(function (_a) {
                var fieldName = _a[0], file = _a[1];
                files["step-".concat(stepIndex, "-").concat(fieldName)] = file;
            });
        });
        return files;
    }, [autofillFiles]);
    var buildPayload = React.useCallback(function () {
        var _a, _b, _c;
        var stepPayloads = stepRefs.current.reduce(function (payload, stepHandle) { var _a; return (__assign(__assign({}, payload), ((_a = stepHandle === null || stepHandle === void 0 ? void 0 : stepHandle.getPayload()) !== null && _a !== void 0 ? _a : {}))); }, {});
        return __assign({ applicationType: (_a = selection.applicationType) !== null && _a !== void 0 ? _a : APPLICATION_TYPES.LOC, selection: (_b = selection) !== null && _b !== void 0 ? _b : null, context: applicationContext, applicationId: draftApplicationId, locAspireOId: (_c = selectedLoc === null || selectedLoc === void 0 ? void 0 : selectedLoc.transactionNum) !== null && _c !== void 0 ? _c : '', isRentalFleetLoc: Boolean(selectedLoc === null || selectedLoc === void 0 ? void 0 : selectedLoc.isRentalFleet), assetLocations: assetLocationChoices }, stepPayloads);
    }, [
        applicationContext,
        assetLocationChoices,
        draftApplicationId,
        selection,
        selectedLoc,
    ]);
    var readCustomerName = React.useCallback(function () { return readPrimaryCustomerName(buildPayload()); }, [buildPayload]);
    var handleSubmit = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var invalidStepIndex, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitError('');
                    invalidStepIndex = stepRefs.current.findIndex(function (stepHandle) { return stepHandle && !stepHandle.validate(); });
                    if (invalidStepIndex >= 0) {
                        goToStep(invalidStepIndex);
                        setSubmitError(STEP_INVALID_MESSAGE);
                        return [2];
                    }
                    setIsSubmitting(true);
                    return [4, submitCreateApplication(buildPayload(), collectFiles())];
                case 1:
                    result = _a.sent();
                    setIsSubmitting(false);
                    if (result.isSuccess) {
                        setSuccessMessage(result.message);
                        return [2];
                    }
                    setSubmitError(result.message);
                    utility.alert(result.message, constants.TOAST_TYPES.ERROR);
                    return [2];
            }
        });
    }); }, [buildPayload, collectFiles, goToStep]);
    var goToApplicationManagement = React.useCallback(function () {
        navigate(NavigationConfig.BacklogManagement);
    }, [navigate]);
    var takedownRaisedFor = React.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return ({
            dealerAspireOId: (_a = selection.dealershipId) !== null && _a !== void 0 ? _a : '',
            dealerName: (_b = selection.dealer) !== null && _b !== void 0 ? _b : '',
            locationAspireOId: (_c = selection.locationId) !== null && _c !== void 0 ? _c : '',
            locationCode: (_d = selection.locationCode) !== null && _d !== void 0 ? _d : '',
            locationName: (_e = selection.location) !== null && _e !== void 0 ? _e : '',
            salesRepId: (_f = selection.salesRepId) !== null && _f !== void 0 ? _f : '',
            salesRepName: (_g = selection.salesRep) !== null && _g !== void 0 ? _g : '',
            salesRepAccountAspireId: (_k = (_j = (_h = selection.dealerEntries) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.salesRepAccountAspireId) !== null && _k !== void 0 ? _k : '',
        });
    }, [
        selection.dealer,
        selection.dealershipId,
        selection.location,
        selection.locationCode,
        selection.locationId,
        selection.salesRep,
        selection.salesRepId,
        selection.dealerEntries,
    ]);
    var handleTakedownLocSelect = React.useCallback(function (locApplication, takedown) {
        setSelection(function (previousSelection) {
            var dealer = takedown.dealerName || previousSelection.dealer || '';
            var location = takedown.locationName || previousSelection.location || '';
            var salesRep = takedown.salesRepName || previousSelection.salesRep || '';
            return __assign(__assign({}, previousSelection), { programAspireOId: takedown.programAspireOId, programId: takedown.programId, program: takedown.programName || previousSelection.program, dealershipId: takedown.dealerAspireOId, dealer: dealer, locationId: takedown.locationAspireOId, locationCode: takedown.locationCode, location: location, salesRepId: takedown.salesRepId, salesRep: salesRep, dealerEntries: [
                    {
                        dealershipId: takedown.dealerAspireOId,
                        dealer: dealer,
                        locationId: takedown.locationAspireOId,
                        locationCode: takedown.locationCode,
                        location: location,
                        salesRepId: takedown.salesRepId,
                        salesRep: salesRep,
                        salesRepAccountAspireId: takedown.salesRepAccountAspireId,
                    },
                ] });
        });
        setLocDetails({
            transactionNum: locApplication.transactionNum,
            approvedAmount: locApplication.approvedAmount,
            availableAmount: locApplication.availableAmount,
            expirationDate: locApplication.expirationDate,
            status: locApplication.status,
            isRentalFleet: locApplication.isRentalFleet,
        });
        setSelectedLoc(locApplication);
        fetchLocAmountsInfo(locApplication.transactionNum, takedown.programAspireOId).then(function (amounts) {
            if (amounts) {
                setLocDetails(amounts);
            }
        });
    }, []);
    var isTakedownLocPicker = selection.applicationType === APPLICATION_TYPES.SCH && !selectedLoc;
    var leaveGuard = useUnsavedChangesGuard(!successMessage);
    var _7 = React.useState([]), previewSteps = _7[0], setPreviewSteps = _7[1];
    var _8 = React.useState(false), isPreviewOpen = _8[0], setIsPreviewOpen = _8[1];
    var openPreview = React.useCallback(function () {
        setPreviewSteps(stepRefs.current
            .map(function (stepHandle) { var _a, _b; return (_b = (_a = stepHandle === null || stepHandle === void 0 ? void 0 : stepHandle.getPreview) === null || _a === void 0 ? void 0 : _a.call(stepHandle)) !== null && _b !== void 0 ? _b : null; })
            .filter(function (preview) { return Boolean(preview); }));
        setIsPreviewOpen(true);
    }, []);
    var closePreview = React.useCallback(function () { return setIsPreviewOpen(false); }, []);
    var _9 = React.useState(false), isSubmitConfirmationOpen = _9[0], setIsSubmitConfirmationOpen = _9[1];
    var openSubmitConfirmation = React.useCallback(function () { return setIsSubmitConfirmationOpen(true); }, []);
    var closeSubmitConfirmation = React.useCallback(function () { return setIsSubmitConfirmationOpen(false); }, []);
    var confirmSubmit = React.useCallback(function () {
        setIsSubmitConfirmationOpen(false);
        closePreview();
        handleSubmit();
    }, [closePreview, handleSubmit]);
    var clearSubmitError = React.useCallback(function () { return setSubmitError(''); }, []);
    var preventSubmit = React.useCallback(function (event) { return event.preventDefault(); }, []);
    var editCustomers = React.useCallback(function () { var _a; return goToStep((_a = stepIndexByIdRef.current[CREATE_APPLICATION_STEP_ID.CustomerInformation]) !== null && _a !== void 0 ? _a : 0); }, [goToStep]);
    var editGuarantors = React.useCallback(function () { var _a; return goToStep((_a = stepIndexByIdRef.current[CREATE_APPLICATION_STEP_ID.GuarantorInformation]) !== null && _a !== void 0 ? _a : 0); }, [goToStep]);
    var renderStepContent = function (stepId, stepIndex) {
        var _a, _b, _c;
        switch (stepId) {
            case CREATE_APPLICATION_STEP_ID.CustomerInformation:
                return (React.createElement(CustomerInformationStep, { ref: stepRefSetters[stepIndex], onAutofillDocument: handleAutofillDocument, onAutofillDocumentRemove: handleAutofillDocumentRemove, autofillContext: autofillContext, onDraftApplicationId: handleDraftApplicationId, isDriverLicenseAutofillEnabled: isDriverLicenseAutofillEnabled, isSmartAutofillEnabled: !isScheduleTakedownType, isCanadaProgram: isCanadaProgram, canAddCustomers: !isScheduleTakedownType, locTxAspireOId: (_a = selectedLoc === null || selectedLoc === void 0 ? void 0 : selectedLoc.transactionNum) !== null && _a !== void 0 ? _a : '', collectsGuarantor: collectsGuarantor, isConsumerProgram: isConsumerProgram }));
            case CREATE_APPLICATION_STEP_ID.GuarantorInformation:
                return (React.createElement(GuarantorInformationStep, { ref: stepRefSetters[stepIndex], isCanadaProgram: isCanadaProgram, signerGuarantors: signerGuarantors, customerOptions: guarantorCustomerOptions, vendorConfig: vendorConfig }));
            case CREATE_APPLICATION_STEP_ID.DocumentSignerInformation:
                return (React.createElement(DocumentSignerPreviewStep, { ref: stepRefSetters[stepIndex], preview: documentSignerPreview, onEditCustomers: editCustomers, onEditGuarantors: editGuarantors, collectsGuarantor: collectsGuarantor }));
            case CREATE_APPLICATION_STEP_ID.AssetInformation:
                return (React.createElement(AssetInformationStep, { ref: stepRefSetters[stepIndex], onAddNewLocation: handleAddNewLocation, locationOptions: assetLocationOptions, programAspireOId: (_b = selection.programAspireOId) !== null && _b !== void 0 ? _b : '', vendorConfig: vendorConfig, isPrimaryCustomerVeteran: isPrimaryCustomerVeteran, primaryCustomerState: primaryCustomerState }));
            case CREATE_APPLICATION_STEP_ID.FilesFinanceAndComments:
                return (React.createElement(FinanceAndDocumentsStep, { ref: stepRefSetters[stepIndex], totalAssetCost: totalAssetCost, commentContext: applicationCommentContext, getCustomerName: readCustomerName, programAspireOId: (_c = selection.programAspireOId) !== null && _c !== void 0 ? _c : '', uploadContext: documentUploadContext, onDraftApplicationId: handleDraftApplicationId, isLineOfCredit: isLineOfCreditType, isConsumerProgram: isConsumerProgram, locDetails: locDetails, statesList: statesList, vendorConfig: vendorConfig, isPrimaryCustomerVeteran: isPrimaryCustomerVeteran }));
            default: {
                var configuredGroup = unmatchedGroups.find(function (group) { return "".concat(CONFIGURED_STEP_ID_PREFIX).concat(group.key) === stepId; });
                if (!configuredGroup) {
                    return null;
                }
                return (React.createElement(WizardStepForm, { ref: stepRefSetters[stepIndex], sections: configuredGroup.sections, payloadKey: configuredGroup.key, previewLabel: configuredGroup.label || configuredGroup.key }));
            }
        }
    };
    var leavePrompt = (React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: leaveGuard.isLeaveBlocked, titleText: UNSAVED_CHANGES_TITLE, message: UNSAVED_CHANGES_MESSAGE, acceptBtnText: "Exit Application", acceptCallBack: leaveGuard.confirmLeave, denyBtnText: "Stay On This Page", denyCallBack: leaveGuard.cancelLeave, equalWidthActions: true, cancelCallBack: leaveGuard.cancelLeave }));
    if (isTakedownLocPicker) {
        return (React.createElement(CreateApplicationWrapper, null,
            React.createElement(ApplicationContextBar, { title: applicationTitle, items: contextItems }),
            React.createElement(Box, { className: "wizard-body" },
                React.createElement(Box, { className: "form-panel" },
                    React.createElement(ScheduleTakedownLocList, { initialProgramAspireOId: selection.programAspireOId, raisedFor: takedownRaisedFor, onSelectLoc: handleTakedownLocSelect }))),
            React.createElement(Box, { className: "wizard-footer" },
                React.createElement(CustomButton, { variant: "secondary", MDButton: true, fullWidth: false, onClick: goToApplicationManagement }, "Cancel")),
            leavePrompt));
    }
    return (React.createElement(DynamicFormOverridesProvider, { resolveSections: resolveSections },
        React.createElement(CreateApplicationWrapper, null,
            React.createElement(ApplicationContextBar, { title: applicationTitle, items: contextItems }),
            React.createElement(Box, { className: "wizard-body" },
                React.createElement(ApplicationStepRail, { steps: steps, activeStepIndex: activeStepIndex, completedStepIndexes: completedStepIndexes, onStepSelect: handleStepSelect }),
                React.createElement(Box, { className: "form-panel", component: "form", noValidate: true, onSubmit: preventSubmit },
                    activeStep.id !== CREATE_APPLICATION_STEP_ID.FilesFinanceAndComments && (React.createElement(StepPanelHeader, { icon: STEP_ICONS[activeStep.id], title: activeStep.label })),
                    hasNoConfiguredFields && (React.createElement(Alert, { severity: "info", sx: SUBMIT_ERROR_SX }, NO_CONFIG_MESSAGE)),
                    submitError && (React.createElement(Alert, { severity: "error", sx: SUBMIT_ERROR_SX, onClose: clearSubmitError }, submitError)),
                    steps.map(function (step, stepIndex) { return (React.createElement(Box, { key: step.id, role: "group", "aria-label": step.label, sx: stepPanelSx(stepIndex === activeStepIndex) }, renderStepContent(step.id, stepIndex))); }))),
            React.createElement(Box, { className: "wizard-footer" },
                React.createElement(CustomButton, { variant: "secondary", MDButton: true, fullWidth: false, disabled: isSubmitting, onClick: goToApplicationManagement }, "Cancel"),
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1.5, flexWrap: "wrap" },
                    isLastStep && (React.createElement(CustomButton, { variant: "text", MDButton: true, fullWidth: false, textColor: WIZARD_COLORS.label, disabled: isSubmitting, onClick: openPreview }, "Preview")),
                    React.createElement(CustomButton, { variant: "secondary", MDButton: true, fullWidth: false, startIcon: React.createElement(ArrowBackIcon, { sx: FOOTER_ICON_SX }), disabled: activeStepIndex === 0 || isSubmitting, sx: INERT_WHEN_DISABLED_SX, onClick: handleBack }, "Back"),
                    isLastStep ? (React.createElement(CustomButton, { variant: "contained", MDButton: true, fullWidth: false, bgColor: FOOTER_PRIMARY_COLOR, disabled: isSubmitting, onClick: handleSubmit }, isSubmitting ? 'Submitting…' : 'Submit')) : (React.createElement(CustomButton, { variant: "contained", MDButton: true, fullWidth: false, endIcon: React.createElement(ArrowForwardIcon, { sx: FOOTER_ICON_SX }), bgColor: FOOTER_PRIMARY_COLOR, onClick: handleNext }, "Next")))),
            leavePrompt,
            React.createElement(ApplicationPreviewDialog, { open: isPreviewOpen, title: applicationTitle, steps: previewSteps, isSubmitting: isSubmitting, onClose: closePreview, onSubmit: openSubmitConfirmation }),
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: isSubmitConfirmationOpen, titleText: "Confirm Submission", message: "Are you sure you want to submit this application?", acceptBtnText: "Yes", acceptCallBack: confirmSubmit, denyBtnText: "No", denyCallBack: closeSubmitConfirmation, cancelCallBack: closeSubmitConfirmation }),
            React.createElement(AddNewLocationDialog, { open: isAddLocationOpen, onClose: function () { return setIsAddLocationOpen(false); }, onSave: handleSaveNewLocation }),
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, open: Boolean(successMessage), titleText: "Application Created", message: successMessage, acceptBtnText: "Go To Application Management", acceptCallBack: goToApplicationManagement }))));
};
export default CreateApplication;
